import i18next from "i18next";

const getNameVarFieldRequiredMessage = () => i18next.t("{{name}} is not Allowed!");
const getFieldRequiredMessage = () => i18next.t("Field is required");
const getMin5PasswordChar = () =>
  i18next.t("Password must be at least 5 characters long");
const getMin6PasswordMessage = () =>
  i18next.t("Password must be at least 6 characters");
const getPasswordMatchMessage = () => i18next.t("Passwords must match");
const getPasswordError = () =>
  i18next.t(
    "Password must include one uppercase letter, one number, and one special character"
  );
const getValidArabicMessage = () =>
  i18next.t("Please enter a valid Arabic text");
const getOnlyNumMessage = () =>
  i18next.t("This field must contain only numbers");
const getValidEmail = () => i18next.t("Please enter a valid email address");

export {
  getFieldRequiredMessage,
  getMin5PasswordChar,
  getMin6PasswordMessage,
  getPasswordMatchMessage,
  getPasswordError,
  getValidArabicMessage,
  getOnlyNumMessage,
  getValidEmail,
  getNameVarFieldRequiredMessage
};
